"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var EventEmitter = require('events').EventEmitter;

var UIControl =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(UIControl, _EventEmitter);

  function UIControl() {
    var _this;

    _classCallCheck(this, UIControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UIControl).call(this));
    _this.managedEvents = [];
    _this.children = [];
    _this.rootElement = document.createElement('div');

    _this.rootElement.setAttribute('x-aui-name', _this.constructor.name);

    _this.rootElement.classList.add('ui-control');

    _this.rootElement.classList.add('x-aui-' + _this.constructor.name);

    return _this;
  }

  _createClass(UIControl, [{
    key: "addManagedEventListener",
    value: function addManagedEventListener(sourceElement, eventName, fct) {
      //let handler = fct.bind(this);
      var handler = fct;
      this.managedEvents.push({
        sourceElement: sourceElement,
        eventName: eventName,
        handler: handler
      });

      if (this.rootElement.parentElement != null) {
        this._bindEventListener(sourceElement, eventName, handler);
      }
    }
  }, {
    key: "removeManagedEventListener",
    value: function removeManagedEventListener(sourceElement, eventName, fct) {
      var _this2 = this;

      this.managedEvents.forEach(function (event, index) {
        if (event.sourceElement === sourceElement, event.eventName === eventName, event.handler === fct) {
          _this2.managedEvents.splice(index, 1);
        }
      });
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this3 = this;

      this.managedEvents.forEach(function (event) {
        _this3._bindEventListener(event.sourceElement, event.eventName, event.handler);
      });
    }
  }, {
    key: "_bindEventListener",
    value: function _bindEventListener(sourceElement, eventName, fct) {
      if (sourceElement.on != null) {
        sourceElement.on(eventName, fct);
      } else {
        sourceElement.addEventListener(eventName, fct);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      this.managedEvents.forEach(function (event) {
        if (event.sourceElement.removeListener != null) {
          event.sourceElement.removeListener(event.eventName, event.handler);
        } else {
          event.sourceElement.removeEventListener(event.eventName, event.handler);
        }
      });
    }
  }, {
    key: "addChild",
    value: function addChild(newChild) {
      this.rootElement.appendChild(newChild.rootElement);
      this.children.push(newChild);
      newChild.parent = this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(oldChild) {
      this.rootElement.removeChild(oldChild.rootElement);

      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i] === oldChild) {
          arr.splice(i, 1);
        }
      }

      oldChild.parent = null;
    }
  }, {
    key: "addedToParent",
    value: function addedToParent() {
      this.bindEvents();
    }
  }, {
    key: "removedFromParent",
    value: function removedFromParent() {
      this.unbindEvents();
    }
  }, {
    key: "keyDown",
    value: function keyDown() {//e.captured = true;
      //console.log('inkeydown');
    }
  }, {
    key: "parent",
    set: function set(newParent) {
      if (this._parent != null) {
        this.removedFromParent();
      }

      this._parent = newParent;

      if (newParent != null) {
        this.addedToParent(); //Check for conformity

        /*if (this.rootElement.parentNode != this.parent.rootElement) {
            throw 'Parent node differs from the expected one';
        }*/
      } else {
        if (this.rootElement.parentNode != null) {
          throw 'Parent node should be null';
        }
      }
    },
    get: function get() {
      return this._parent;
    }
  }, {
    key: "display",
    set: function set(value) {
      this.rootElement.style.display = value ? "" : "none";
    },
    get: function get() {
      return !(this.rootElement.style.display == "");
    }
  }, {
    key: "focused",
    set: function set(value) {
      this._focused = value;
      if (value) this.rootElement.classList.add('x-aui-focused');else this.rootElement.classList.remove('x-aui-focused');
    },
    get: function get() {
      return this._focused;
    }
  }]);

  return UIControl;
}(EventEmitter);

exports["default"] = UIControl;

var UIAds =
/*#__PURE__*/
function (_UIControl) {
  _inherits(UIAds, _UIControl);

  function UIAds(player) {
    var _this4;

    _classCallCheck(this, UIAds);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(UIAds).call(this));

    _defineProperty(_assertThisInitialized(_this4), "skipClicked", function () {
      var currentCreative = _this4.squadeoPlayer.adManager.currentCreative;

      if (currentCreative.skipDelay != null && currentCreative.skipDelay <= _this4.squadeoPlayer.adManager.adPosition) {
        _this4.squadeoPlayer.adManager.skipAd();
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "adBreaksLoaded", function () {
      _this4.removeManagedEventListener(_this4.squadeoPlayer, 'adBreakStarted', _this4.adBreakStarted);

      _this4.removeManagedEventListener(_this4.squadeoPlayer, 'adBreakEnded', _this4.adBreakEnded);

      _this4.removeManagedEventListener(_this4.squadeoPlayer, 'adStarted', _this4.adStarted);

      _this4.removeManagedEventListener(_this4.squadeoPlayer, 'adEnded', _this4.adEnded);

      _this4.removeManagedEventListener(_this4.squadeoPlayer, 'adTimeUpdated', _this4.adTimeUpdated);

      _this4.addManagedEventListener(_this4.squadeoPlayer, 'adBreakStarted', _this4.adBreakStarted);

      _this4.addManagedEventListener(_this4.squadeoPlayer, 'adBreakEnded', _this4.adBreakEnded);

      _this4.addManagedEventListener(_this4.squadeoPlayer, 'adStarted', _this4.adStarted);

      _this4.addManagedEventListener(_this4.squadeoPlayer, 'adEnded', _this4.adEnded);

      _this4.addManagedEventListener(_this4.squadeoPlayer, 'adTimeUpdated', _this4.adTimeUpdated);
    });

    _defineProperty(_assertThisInitialized(_this4), "adBreakStarted", function () {
      console.log('ad break started');
      _this4.display = true;
    });

    _defineProperty(_assertThisInitialized(_this4), "adBreakEnded", function () {
      console.log('ad break ended');
      _this4.display = false;
    });

    _defineProperty(_assertThisInitialized(_this4), "adStarted", function () {
      var adNumber = _this4.squadeoPlayer.adManager.currentVASTData.ads.length - _this4.squadeoPlayer.adManager.remainingAdsInBreak.length;
      var adCount = _this4.squadeoPlayer.adManager.currentVASTData.ads.length;
      _this4.adCount.value = "Ad ".concat(adNumber, "/").concat(adCount);
      _this4.progressBar.percentage = 0;

      _this4.updateSkipButton();
    });

    _defineProperty(_assertThisInitialized(_this4), "adEnded", function () {});

    _defineProperty(_assertThisInitialized(_this4), "adTimeUpdated", function () {
      _this4.progressBar.percentage = _this4.squadeoPlayer.adManager.adPosition / _this4.squadeoPlayer.adManager.adDuration * 100;

      _this4.updateSkipButton();
    });

    _this4.squadeoPlayer = player;
    _this4.parentElement = _this4.squadeoPlayer.video_.parentElement;

    _this4.rootElement.classList.add("ad-root");

    _this4.progressBar = new ProgressBar();

    _this4.progressBar.rootElement.classList.add('ui-ads-ad-progress');

    _this4.addChild(_this4.progressBar);

    _this4.adCount = new UIText();
    _this4.adCount.value = 'Hello';

    _this4.addChild(_this4.adCount);

    _this4.skipButton = new SkipButton();

    _this4.addChild(_this4.skipButton);

    _this4.parentElement.appendChild(_this4.rootElement);

    _this4.addManagedEventListener(_this4.skipButton, 'click', _this4.skipClicked);

    _this4.addManagedEventListener(_this4.squadeoPlayer, 'adBreaksLoaded', _this4.adBreaksLoaded);

    _this4.display = false;
    return _this4;
  }

  _createClass(UIAds, [{
    key: "updateSkipButton",
    value: function updateSkipButton() {
      var currentCreative = this.squadeoPlayer.adManager.currentCreative;

      if (currentCreative.skipDelay == null || currentCreative.skipDelay > this.squadeoPlayer.adManager.adDuration) {
        this.skipButton.waitFor = Infinity;
        this.skipButton.display = false;
      } else {
        this.skipButton.waitFor = currentCreative.skipDelay - this.squadeoPlayer.adManager.adPosition;
        this.skipButton.display = true;
      }
    }
  }]);

  return UIAds;
}(UIControl);

var ProgressBar =
/*#__PURE__*/
function (_UIControl2) {
  _inherits(ProgressBar, _UIControl2);

  function ProgressBar() {
    var _this5;

    _classCallCheck(this, ProgressBar);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ProgressBar).call(this));

    _this5.rootElement.classList.add('progress-bar');

    _this5.positionBar = document.createElement('div');

    _this5.positionBar.classList.add('position-bar');

    _this5.rootElement.appendChild(_this5.positionBar);

    _this5.percentage = 0;
    return _this5;
  }

  _createClass(ProgressBar, [{
    key: "percentage",
    set: function set(value) {
      this._percentage = value;
      this.positionBar.style.width = "".concat(Math.round(value), "%");
    },
    get: function get() {
      return this._percentage;
    }
  }]);

  return ProgressBar;
}(UIControl);

var Button =
/*#__PURE__*/
function (_UIControl3) {
  _inherits(Button, _UIControl3);

  function Button() {
    var _this6;

    _classCallCheck(this, Button);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this));

    _defineProperty(_assertThisInitialized(_this6), "activated", function () {
      _this6.emit('click');
    });

    _this6.rootElement.classList.add('ad-button');

    _this6.text = new UIText();

    _this6.addChild(_this6.text);

    _this6.addManagedEventListener(_this6.rootElement, 'click', _this6.activated);

    return _this6;
  }

  _createClass(Button, [{
    key: "value",
    get: function get() {
      return this.text.value;
    },
    set: function set(val) {
      this.text.value = val;
    }
  }]);

  return Button;
}(UIControl);

var SkipButton =
/*#__PURE__*/
function (_Button) {
  _inherits(SkipButton, _Button);

  function SkipButton() {
    var _this7;

    _classCallCheck(this, SkipButton);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(SkipButton).call(this));

    _this7.rootElement.classList.add('ad-skip-button');

    _this7.text.rootElement.classList.add('skip-button-text');

    return _this7;
  }

  _createClass(SkipButton, [{
    key: "waitFor",
    set: function set(value) {
      if (value <= 0) {
        this.value = "Skip";
      } else if (value == Infinity) {
        this.value = "Watch ad until the end";
      } else {
        this.value = "You can skip in ".concat(Math.ceil(value), " seconds.");
      }
    }
  }]);

  return SkipButton;
}(Button);

var UIText =
/*#__PURE__*/
function (_UIControl4) {
  _inherits(UIText, _UIControl4);

  function UIText() {
    var _this8;

    _classCallCheck(this, UIText);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(UIText).call(this));

    _this8.rootElement.classList.add('ui-text');

    return _this8;
  }

  _createClass(UIText, [{
    key: "value",
    set: function set(val) {
      this.rootElement.innerText = val;
    },
    get: function get() {
      return this.rootElement.innerText;
    }
  }]);

  return UIText;
}(UIControl);

console.info('UIAds loaded');
window.UIAds = UIAds;
window.UIControl = UIControl;